import { render, staticRenderFns } from "./SafetyPreventionRequest.vue?vue&type=template&id=cc962dc8&scoped=true&"
import script from "./SafetyPreventionRequest.vue?vue&type=script&lang=js&"
export * from "./SafetyPreventionRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc962dc8",
  null
  
)

export default component.exports